import "react-native-get-random-values";
import { registerRootComponent } from "expo";
import { ExpoRoot } from "expo-router";
import * as React from "react";

// Must be exported or Fast Refresh won't update the context
export function App() {
  return (
    <ExpoRoot
      context={
        // @ts-expect-error: we need this for web build
        process.env.EXPO_PUBLIC_APP_VARIANT === "web"
          ? require.context("./app", true, /\.[jt]sx?$/)
          : require.context("./app")
      }
    />
  );
}

registerRootComponent(App);
